import { useCallback, useEffect, useMemo, useState } from 'react'

import createContextFactory from '@/utils/factory'

const SIZE_PER_PAGE = 25

function usePagination() {
  const [_, setPage] = useState(1)
  const [sizePerPage, setSizePerPage] = useState(SIZE_PER_PAGE)

  const onNextPage = useCallback(() => {
    setPage(page => {
      page = page + 1
      setSizePerPage(SIZE_PER_PAGE * 2 ** (page - 1))
      return page
    })
  }, [])

  const reset = useCallback(() => {
    setPage(1)
    setSizePerPage(SIZE_PER_PAGE)
  }, [])

  return useMemo(() => ({
    options: {
      page: 1,
      sizePerPage,
    },
    onNextPage,
    reset,
  }), [sizePerPage, onNextPage, reset])
}

function useFilters() {
  const [term, setTerm] = useState('')
  const [search, setSearch] = useState('')
  const [filters, setFilters] = useState({})

  useEffect(() => {
    setTerm(() => {
      const terms = []
      if (search) {
        terms.push(search)
      }

      if (filters) {
        Object.entries(filters).forEach(([key, value]) => {
          if (value) {
            terms.push(`${key}=${JSON.stringify(value)}`)
          }
        })
      }
      return terms.join(' ')
    })
  }, [search, filters])

  return useMemo(() => ({
    term,
    search, setSearch,
    filters, setFilters,
  }), [term, search, setSearch, filters, setFilters])
}

const { Provider: BlocksProvider, useContext: useBlocks } = createContextFactory(() => {
  const pagination = usePagination()
  const filters = useFilters()

  return useMemo(() => ({
    pagination,
    filters,
  }), [pagination, filters])
})

export {
  BlocksProvider,
  useBlocks,
}
